/**
 * Utilities for the Draft JS powered EditorInput component
 */
// import _ from 'lodash'
import balanced from 'node-balanced'

const QUOTE_REGEX = new RegExp('\'|"|`', 'g')


export const IDE_PART_TYPES = {
  VALUE: 'VALUE', // value in input string, should still map to an output name in ideState
  KEY_VALUE: 'KEY_VALUE', // fieldname + operator + value
  GROUP: 'GROUP', // grouping of other ordered parts
  INVALID_RANGE: 'INVALID_RANGE', // invalid textRange, corresponding to an indexed validation message
}


export function getQuoteRanges (inputString) {
  const quoteRanges = balanced.getRangesForMatch(inputString, QUOTE_REGEX)
  const outputRanges = []
  let current = null
  for (var i = 0; i < quoteRanges.length; i++) {
    const quote = quoteRanges[i]
    if (current && current.match === quote.match) {
      outputRanges.push({
        index: current.index,
        length: quote.index - current.index + 1
      })
      current = null
    } else if (!current) {
      current = quote
    }
  }
  return outputRanges
}



// Strip smart single/double quotes, and also single/double prime symbols
export function stripSmartQuotes (inputString) {
  return inputString
    .replace(/[\u2018\u2019\u2032]/g, "'")
    .replace(/[\u201C\u201D\u2033\u2034]/g, '"')
}
